/**
 * Renders button which acts like select.
 * You have to manage state from outside.
 */
import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { Button, IconButton } from '@mui/material';
import { PropTypes } from 'prop-types';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export default function DropdownSelect({
  options,
  value,
  onSelect,
  disabled,
  returnOptionOnSelect,
  btn_testid,
  buttonProps,
  customLabel,
  menuSlotProps,
  showArrow = true,
  isIconButton = false,
  preventTranslation = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getOption = (value) => options.find((o) => o.value === value);

  const handleMenuItemClick = (value) => {
    const valueToReturn = returnOptionOnSelect ? getOption(value) : value;
    onSelect(valueToReturn);

    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const activeOption = getOption(value);

  const RenderButton = isIconButton ? IconButton : Button;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        textAlign: 'center',
        alignItems: 'center',
      }}
      data-testid="dropdownselectbutton"
      data-use-translation={!preventTranslation}
    >
      <RenderButton
        size="small"
        color="primary"
        disabled={disabled}
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClickListItem}
        style={{ fontSize: '1rem' }}
        data-testid={btn_testid}
        {...buttonProps}
      >
        {customLabel ? customLabel : activeOption?.label || activeOption?.value}
        {!isIconButton && showArrow ? <ArrowDropDownIcon /> : null}
      </RenderButton>

      <Menu
        slotProps={menuSlotProps}
        sx={{ zIndex: 0 }}
        id="lock-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option, index) => (
          <MenuItem
            id={option.label || option.value}
            key={index}
            disabled={option.disabled}
            selected={option.value === value}
            onClick={() => handleMenuItemClick(option.value)}
            data-use-translation={!preventTranslation}
          >
            {option.label || option.value}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

DropdownSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // not required, if not provided, value will be used like a label
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  returnOptionOnSelect: PropTypes.bool, // option object instead value will be provided to onSelect
};
